<template>
    <div>
        <navbar/>
        <b-container class="mt-4">
            <h4>Reset Password</h4>
            <b-form @submit.prevent="resetPassword">

                <b-input-group>
                    <b-input :type="passType" v-model="password" required placeholder="Password" :disabled="lockForm"></b-input>
                    <template #append>
                        <b-btn type="button" variant="light" class="border" @click="togglePasswordVisibility">
                            <span v-if="passType == 'password'">
                                <font-awesome-icon :icon="['fad', 'eye-slash']" fixed-width />
                            </span>
                            <span v-else>
                                <font-awesome-icon :icon="['fad', 'eye']" fixed-width />
                            </span>
                        </b-btn>
                    </template>
                </b-input-group>
                <b-input-group class="mt-2">
                    <b-input :type="passType2" v-model="passwordConfirmation" required placeholder="Password Confirmation" :disabled="lockForm"></b-input>
                    <template #append>
                        <b-btn type="button" variant="light" class="border" @click="toggleConfirmVisibility">
                                <span v-if="passType2 == 'password'">
                                    <font-awesome-icon :icon="['fad', 'eye-slash']" fixed-width />
                                </span>
                            <span v-else>
                                    <font-awesome-icon :icon="['fad', 'eye']" fixed-width />
                                </span>
                        </b-btn>
                    </template>
                </b-input-group>
                <b-btn type="submit" variant="primary" :disabled="!password || !passwordConfirmation || lockForm" class="mt-2" >Reset Password</b-btn>
            </b-form>
        </b-container>
        <footer/>
    </div>
</template>

<script>
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
const PASS_LEN = 5;

export default {
    name: "ResetPassword",
    components: {Footer, Navbar},
    props: ['code'],
    data: () => ({
        password: null,
        passwordConfirmation: null,
        validated: false,
        lockForm: false,
        passType: 'password',
        passType2: 'password',
    }),
    methods: {
        resetPassword() {
            if (!this.validate())
                return;

            this.axios.post('/auth/resetPassword', {
                password: this.password,
                password_confirmation: this.passwordConfirmation,
                code: this.code
            })
            .then((response) => {
                this.$router.push({name:'login'});
            }).catch((error => {
                this.$swal({
                    title: 'Error',
                    text: error.response.data.message,
                    icon: 'error',
                    showConfirmButton: true
                })
            }));
        },
        validate() {
            if (this.password != this.passwordConfirmation) {
                this.$swal({
                    title: 'Passwords do not match',
                    icon: 'error',
                    timer: 2000,
                    showConfirmButton: false
                })
                this.validated = false;
                return;
            }
            if (this.password.length < PASS_LEN) {
                this.$swal({
                    title: 'Password must be at least ' + PASS_LEN + ' characters long',
                    icon: 'error',
                    timer: 2000,
                    showConfirmButton: false
                })
                this.validated = false;
                return;
            }
            this.validated = true;
            return this.validated;
        },
        togglePasswordVisibility() {
            this.passType = (this.passType == 'password') ? 'text' : 'password';
        },
        toggleConfirmVisibility() {
            this.passType2 = (this.passType2 == 'password') ? 'text' : 'password';
        }
    }
}
</script>

<style scoped>

</style>